import EmblaCarousel from "embla-carousel";

document.addEventListener("DOMContentLoaded", () => {
  const button = document.getElementById("grid-type");
  const grid = document.getElementById("shop-grid");
  const iconGrid = button?.querySelector(".icon-grid");
  const iconList = button?.querySelector(".icon-list");

  if (!button || !grid) return;

  button.addEventListener("click", function (ev) {
    ev.preventDefault();
    iconGrid?.toggleAttribute("hidden");
    iconList?.toggleAttribute("hidden");
    grid.classList.toggle("!grid-cols-1");
  });

  document.addEventListener("added_to_cart", function () {
    const modalClose = document.querySelector("dialog[open] .dialog-close");
    modalClose?.click()
  })
});

class ShopLookCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.emblaInitialized === "true") return;

    const viewportNode = this.querySelector(":scope > .embla__viewport");
    const totalSlide = viewportNode.querySelectorAll(".embla__slide").length;

    const prevButtonNode = this.querySelector('.embla__prev')
    const nextButtonNode = this.querySelector('.embla__next')

    if (!viewportNode || totalSlide <= 1) return;


    this.emblaApi = EmblaCarousel(viewportNode, {
      loop: false,
      align: "start",
      breakpoints: {
        "(max-width: 1023px)": {
          active: false
        }
      }
    });

      prevButtonNode.addEventListener('click', () => this.emblaApi.scrollPrev(), false)
      nextButtonNode.addEventListener('click', () => this.emblaApi.scrollNext(), false)

    const toggleToggleButtons = () => {
      console.log("TOGGLE")

      if (this.emblaApi.canScrollPrev()) {
        prevButtonNode.classList.remove('is-hidden')
      } else {
        prevButtonNode.classList.add('is-hidden')
      }

      if (this.emblaApi.canScrollNext()) {
        nextButtonNode.classList.remove('is-hidden')
      } else {
        nextButtonNode.classList.add('is-hidden')
      }
    }    



    this.dataset.emblaInitialized = "true";
    this.emblaApi.on('init', toggleToggleButtons)
    this.emblaApi.on('select', toggleToggleButtons)



  }

  disconnectedCallback() {
    this.emblaApi.destroy();
  }
}

if (!customElements.get("look-carousel")) {
  customElements.define("look-carousel", ShopLookCarousel);
}